import { createContext, createElement, useContext, type ReactNode } from 'react'

/**
 * Where the action items on screen live. The PO action cards render a customer email thread's
 * action items too (USA-1328): inside a customer source their resolve, reopen and reply
 * mutations use the customer communication routes, and replies go to the customer. A manufacturer's
 * data@ items (USA-1474) use the manufacturer data routes the same way, and so do warranty items (USA-915):
 * their routes take the item's UUID (``actionUuids`` by the numeric id the cards pass), and the record whose
 * ``actions`` hold them is cached under ``actionsKey``. ``poUuid`` is the claim's PO, where its emails are.
 */
export type ActionItemSource =
  | { kind: 'purchase_order' }
  | { kind: 'customer_thread'; threadId: number }
  | { kind: 'manufacturer_data'; manufacturerUuid: string }
  | {
      kind: 'warranty_claim'
      actionsKey: readonly unknown[]
      actionUuids: Readonly<Record<number, string>>
      poUuid: string | null
    }

const ActionItemSourceContext = createContext<ActionItemSource>({ kind: 'purchase_order' })

export function ActionItemSourceProvider({
  value,
  children,
}: {
  value: ActionItemSource
  children: ReactNode
}) {
  return createElement(ActionItemSourceContext.Provider, { value }, children)
}

export function useActionItemSource(): ActionItemSource {
  return useContext(ActionItemSourceContext)
}
